import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { curStateAccount } from "../../../../Redux/selector";
import ComponentGive from "./ComponentGive";
import Cookies from "universal-cookie";
import MiniGamePageHome from '../Home';
import { useLoginModal } from '@/contexts/LoginModalContext';

export default function GivePiece() {
  const cookies = new Cookies();
  const selectorAccount = useSelector(curStateAccount);
  const isLogin = cookies.get("isLoggedIn");
  const { openLogin } = useLoginModal();

  const isAuthed = Boolean(selectorAccount?.userInfo) || Boolean(isLogin);

  useEffect(() => {
    if (!isAuthed) {
      openLogin();
    }
  }, [isAuthed]);

  return (
    <>
      {isAuthed ? <ComponentGive /> :  <MiniGamePageHome />}
    </>
  );
}